var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingPlanSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9365 7.23785C9.35851 6.52335 9.60068 5.69004 9.60068 4.80015C9.60068 2.1491 7.45151 0 4.80034 0C2.14919 0 0 2.1491 0 4.80015C0 7.45122 2.14919 9.60031 4.80034 9.60031C5.69027 9.60031 6.5236 9.35814 7.23808 8.9362L10.1258 11.8242C10.3601 12.0586 10.74 12.0586 10.9744 11.8243L11.8243 10.9745C12.0586 10.7402 12.0586 10.3603 11.8243 10.1259L8.9365 7.23785ZM4.80034 7.80025C6.4573 7.80025 7.80056 6.45705 7.80056 4.80015C7.80056 3.14325 6.4573 1.80006 4.80034 1.80006C3.14337 1.80006 1.80013 3.14325 1.80013 4.80015C1.80013 6.45705 3.14337 7.80025 4.80034 7.80025Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingPlanSearchIcon);
export default __webpack_public_path__ + "d8053590bad5a93de55ffe9073ba6cb2.svg";
export { ForwardRef as ReactComponent };